"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiBenefits {
    static getList(token) {
        let url = `/benefits/list?client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static getListFuture(token) {
        let url = `/benefits/list-future`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeeList(token, employeeId) {
        let url = `/benefits/employee-list?client=${token.client}&employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeeListFuture(token, employeeId) {
        let url = `/benefits/employee-list-future?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getDependentsList(token) {
        let url = `/benefits/dependents?client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static getDependent(token, dependentId) {
        let url = `/benefits/dependent?dependentId=${dependentId}&client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static updateDependent(token, body) {
        let url = `/benefits/dependents/update`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getEnrollmentStatus(token, userId) {
        let url = `/benefits/enrollment/status?client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static getEnrollmentStatusInfoList(token) {
        let url = `/benefits/enrollment/status/list`;
        return Client_1.default.httpGet(url, token);
    }
    static getSpendingAccounts(token) {
        let url = `/benefits/spendingaccount?client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeeSpendingAccounts(token, employeeId, isFormer) {
        let url = `/benefits/employee-spendingaccount?client=${token.client}&employeeId=${employeeId}&isFormer=${isFormer}`;
        return Client_1.default.httpGet(url, token);
    }
    static getCards(token) {
        let url = `/benefits/cards?client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeeCards(token, employeeId) {
        let url = `/benefits/employee-cards?client=${token.client}&employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getReimbursementArrangement(token) {
        let url = `/benefits/reimbursement`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeeReimbursementArrangement(token, employeeId) {
        let url = `/benefits/employee-reimbursement?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static startUpload(token, prefix, type, filename, employeeId) {
        let url = `/benefits/upload/start?prefix=${prefix}&type=${type}&filename=${filename}&employeeId=${employeeId ?? ''}`;
        return Client_1.default.httpGet(url, token);
    }
    static listUploads(token, prefix, employeeId) {
        let url = `/benefits/upload/list?prefix=${prefix}&employeeId=${employeeId ?? ''}`;
        return Client_1.default.httpGet(url, token);
    }
    static getPendingLifeEvent(token, employeeId, lifeEventId) {
        let url = `/benefits/lifeevent?employeeId=${employeeId ?? ''}&lifeEventId=${lifeEventId ?? ''}`;
        return Client_1.default.httpGet(url, token);
    }
    // Just returns an empty Ok
    static addLifeEvent(token, body) {
        let url = `/benefits/lifeevent`;
        return Client_1.default.httpPost(url, token, body);
    }
    static isCreditBack(token) {
        let url = `/benefits/isCreditBack`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiBenefits;
